import "./style.css";

import * as Sentry from "@sentry/react";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ampli } from "../../../ampli";
import { Footer } from "../../../components/common/footer";
import { getContractDetails } from "../../../setup/api/services/contract";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import { ROUTES } from "../../../setup/constants";
import { setAppToken } from "../../../setup/context/api";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { EVENT_LOCAL_STORAGE_LOGIN } from "../../../setup/context/events";
import AuthEntryPoint from "../../authentication/authEntryPoint";
import { BreakPoint } from "./breakPoint";
import { ContractDetails } from "./contractDetails";
// styles
import styles from "./styles.module.scss";

const PublicContractDetails = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const { id } = useParams();
  const [contract, setContract] = useState<IContractDetailsResponseData>();
  useEffect(() => {
    if (!AuthConfig.getAppToken())
      setAppToken()
        .then(() => {
          setIsAuthenticated(true);
        })
        .catch(() => {
          setIsAuthenticated(false);
        });
    else setIsAuthenticated(true);
  }, []);
  useEffect(() => {
    if (id && isAuthenticated)
      getContractDetails(id)
        .then((res) => {
          const data = res.data;
          if (!data.receiverId) setContract(data);
          else navigate(ROUTES.CONTRACT_NOT_FOUND);
        })
        .catch((error) => {
          console.error(error);
          navigate(ROUTES.CONTRACT_NOT_FOUND);
        });
  }, [id, isAuthenticated, navigate]);

  const contractPreviewEvent = useCallback((contractId: string) => {
    try {
      const properties = {
        contractId: contractId,
      };
      ampli.contractPreview(properties);
    } catch (error) {
      Sentry.captureException(error);
    }
  }, []);

  useEffect(() => {
    if (contract && ampli) {
      contractPreviewEvent(contract?.shortId);
    }
  }, [contract, contractPreviewEvent]);

  const authAction = () => {
    window.dispatchEvent(new Event(EVENT_LOCAL_STORAGE_LOGIN));
  };
  return contract ? (
    <BreakPoint
      leftElement={
        <div className="login-container">
          <AuthEntryPoint authAction={authAction} publicContractLogin={true} />
          <span className="footer-small">
            <Footer />
          </span>
        </div>
      }
      rightElement={
        <>
          <div className={styles.contract_wrapper}>
            <ContractDetails unAuthenticated={true} contract={contract} />
          </div>
          <span className="footer">
            <Footer />
          </span>
        </>
      }
    />
  ) : null;
};

export default PublicContractDetails;
